import { FC } from 'react'

type IconTriangleUpProps = {
  className?: string
}

export const IconTriangleUp: FC<IconTriangleUpProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="12"
      viewBox="0 0 23 12"
      width="23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8215 0.626817C11.2046 0.272888 11.7954 0.27289 12.1786 0.626819L22.6127 10.2654C23.2812 10.883 22.8443 12 21.9341 12H1.06588C0.155746 12 -0.281212 10.883 0.387328 10.2654L10.8215 0.626817Z"
        fill="#999999"
      />
    </svg>
  )
}
